import React from 'react';
import { useLocale } from '../contexts/LocaleContext';

interface CreditsScreenProps {
  onFinish?: () => void;
  onClose?: () => void;
}

const CreditsScreen: React.FC<CreditsScreenProps> = ({ onFinish, onClose }) => {
  const { t } = useLocale();
  // Logo component using actual logo
  const Logo = () => (
    <img 
      src="/logoAA.webp"
      alt={t('header.museumName')}
      className="w-16 h-16 rounded-lg object-contain"
    />
  );

  const logos = [
    // Row 1
    {
      src: "/logos.webp",
      alt: t('header.museumName'),
    },
  ];

  return (
<div 
  className="fixed inset-0 flex items-center justify-center z-50 p-4"
  style={{ background: 'var(--gradient-primary)' }}
>
  <div className="flex flex-col items-center w-full max-w-2xl h-full text-center animate-fade-in">
    
    {/* Logos Section (same width as text) */}
    <div className="flex flex-col items-center justify-center flex-none gap-6 mt-auto mb-4 p-4 w-full max-w-lg mx-auto">
      <img 
        src={logos[0].src}
        alt={logos[0].alt}
        className="object-contain w-full max-w-full"
        />
    </div>

    {/* Funding Disclaimer (shares same width) */}
    <div className="flex-none px-6 mb-6 w-full max-w-lg mx-auto">
      <p className="text-xs font-medium leading-relaxed opacity-80 text-justify" style={{ color: 'var(--text-primary)' }}>
        {t('credits.fundingDisclaimer')}
      </p>
    </div>

    {/* Close Button */}
    {onClose && (
      <div className="flex-none mb-6 mt-auto w-full max-w-lg mx-auto">
        <button
          onClick={onClose}
          className="px-4 py-2 rounded-lg transition-colors uppercase"
          style={{ 
            backgroundColor: 'var(--color-capsule)',
            color: 'var(--color-capsule-text)'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--color-capsule-hover)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--color-capsule)'}
        >
          {t('credits.close')}
        </button>
      </div>
    )}
  </div>
</div>


  
  );
};

export default CreditsScreen;